import { Nullable } from '@ps/utils';
import { SurveyFormState } from '../types/survey-form.types';

export type SurveyMetadataForm = {
  title: string;
  selectedTemplate: Nullable<number>;
  selectedTags: number[];
  selectedCountries: string[];
  selectedLanguages: string[];
  completes: Nullable<number>;
  loi: Nullable<number>;
  incidence: Nullable<number>;
  fieldTime: Nullable<number>;
  clickBalancing: boolean;
};
export type SurveyMetadataFormState = SurveyFormState<
  Nullable<SurveyMetadataForm>
>;

export const PROJECT_SHARED_METADATA_FIELDS = [
  'title',
  'completes',
  'loi',
  'incidence',
  'fieldTime',
  'clickBalancing',
] as const satisfies readonly (keyof SurveyMetadataForm)[];

export type ProjectSharedMetadataField =
  (typeof PROJECT_SHARED_METADATA_FIELDS)[number];

export type PatchableMetaData = Partial<
  Pick<SurveyMetadataForm, ProjectSharedMetadataField>
>;
